import React from "react";
import { Link } from "react-router-dom";
import kokoLogo from "../assets/images/logo/koko-90x41.png";
import onePayLogo from "../assets/images/logo/onepay-logo-150x150.png";
import cashOnDeliveryLogo from "../assets/images/logo/cash-on-delivary-01-1_1-90x38.png";
import bigmallQRCode from "../assets/images/footer-app-downloads/BIGMALL-QR-CODE.png";
import playstoreLogo from "../assets/images/footer-app-downloads/bigmall-app-playstore.png";
import appstoreLogo from "../assets/images/footer-app-downloads/bigmall-app-appstore.png";
import huaweiLogo from "../assets/images/footer-app-downloads/bigmall-app-huawei.png";
import facebooklogo from "../assets/images/logo/social-media/facebook.png";
import instagramlogo from "../assets/images/logo/social-media/instagram.png";
import tiktoklogo from "../assets/images/logo/social-media/tiktok.png";
import whatsapplogo from "../assets/images/logo/social-media/whatsapp.png";

const FooterOne = () => {
  return (
    <footer className="footer py-10 mt-10 bg-gray-100">
      <div className="container container-md">
        <div className="footer-item-wrapper d-flex align-items-start flex-wrap justify-content-between">
          <div className="footer-item">
            <div className="flex-align gap-16 mb-4">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                <i className="ph-fill ph-phone-call" />
              </span>
              <div className="flex-align gap-16 flex-wrap">
                <Link
                  to="tel:+94777961772"
                  className="text-sm text-gray-900 hover-text-main-600"
                >
                  Hotline: (+94) 777961772
                </Link>
              </div>
            </div>
            <div className="flex-align gap-16 mb-16">
              <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                <i className="ph-fill ph-envelope" />
              </span>
              <Link
                to="mailto:info@bigmall.lk"
                className="text-sm text-gray-900 hover-text-main-600"
              >
                info@bigmall.lk
              </Link>
            </div>
            <div className="text-sm text-gray-900 mb-8">
              <span className="text-sm text-main-600 ">Connect with us </span>
            </div>
            <div className="flex-align gap-16 mb-8">
              <Link to="https://www.facebook.com/bigmall.lk">
                {/* <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                  <i className="bi bi-facebook" />
                </span> */}
                <img
                  src={facebooklogo}
                  alt="Facebook"
                  width="32"
                  height="32"
                  className="rounded-circle"
                />
              </Link>
              <Link to="https://wa.me/94777961772">
                {/* <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                  <i className="bi bi-whatsapp" />
                </span> */}
                <img
                  src={whatsapplogo}
                  alt="WhatsApp"
                  width="32"
                  height="32"
                  className="rounded-circle"
                />
              </Link>
              <Link to="https://www.instagram.com/bigmall.lk">
                {/* <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                  <i className="bi bi-instagram" />
                </span> */}
                <img
                  src={instagramlogo}
                  alt="Instagram"
                  width="32"
                  height="32"
                  className="rounded-circle"
                />
              </Link>
              <Link to="https://www.tiktok.com/@bigmall.lk">
                {/* <span className="w-32 h-32 flex-center rounded-circle bg-main-600 text-white text-sm flex-shrink-0">
                  <i className="bi bi-tiktok" />
                </span> */}
                <img
                  src={tiktoklogo}
                  alt="TikTok"
                  width="32"
                  height="32"
                  className="rounded-circle"
                />
              </Link>
            </div>
          </div>

          <div className="footer-item">
            <h6 className="footer-item__title text-sm mb-4">Detailed Pages</h6>
            <ul className="footer-menu">
              <li className="mb-8">
                <Link
                  to="/contact"
                  className="text-gray-600 hover-text-main-600 text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li className="mb-8">
                <Link
                  to="/about-us"
                  className="text-gray-600 hover-text-main-600 text-sm"
                >
                  About Us
                </Link>
              </li>
              <li className="mb-8">
                <Link
                  to="/terms-and-conditions"
                  className="text-gray-600 hover-text-main-600 text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li className="mb-8">
                <Link
                  to="/return-policy"
                  className="text-gray-600 hover-text-main-600 text-sm"
                >
                  Refund & Returns Policy
                </Link>
              </li>
              <li className="mb-8">
                <Link
                  to="/privacy-policy"
                  className="text-gray-600 hover-text-main-600 text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-item ">
            <h6 className="footer-item__title text-sm mb-4">We Accept</h6>
            <ul className="footer-menu">
              <li>
                <div className="flex-align gap-8 flex-wrap">
                  <a href="https://www.payhere.lk" target="_blank">
                    <img
                      src="https://www.payhere.lk/downloads/images/payhere_short_banner_dark.png"
                      alt="PayHere"
                      width="250"
                    />
                  </a>
                </div>
              </li>
              <li>
                <div className="flex-align gap-8 flex-wrap">
                  <img
                    src={cashOnDeliveryLogo}
                    alt="COD"
                    width="90"
                    height="38"
                  />
                  <img src={kokoLogo} alt="KoKo" width="90" height="41" />
                  <img src={onePayLogo} alt="Onepay" width="82" height="82" />
                </div>
              </li>
            </ul>
          </div>
          <div className="footer-item text-center pb-40">
            <h6 className="footer-item__title text-sm mb-4">
              Download The Big Mall App
            </h6>
            <ul className="footer-menu">
              <li>
                <div className="flex-align gap-8 flex-wrap justify-content-center">
                  <img
                    src={bigmallQRCode}
                    alt="QR Code"
                    width="100"
                    height="38"
                  />
                  <div className="d-flex flex-column gap-4 ">
                    <a href="https://play.google.com/store/apps/details?id=com.fourdiv.bigmall&pcampaignid=web_share">
                      <img
                        src={playstoreLogo}
                        alt="Playstore"
                        width="100"
                        height="41"
                      />
                    </a>
                    <a href="https://apps.apple.com/lk/app/bigmall-online-shopping-app/id6503951842">
                      <img
                        src={appstoreLogo}
                        alt="Appstore"
                        width="100"
                        height="82"
                      />
                    </a>
                    {/* <a href="https://urldra.cloud.huawei.com/rHAAmApjRC">
                      <img
                        src={huaweiLogo}
                        alt="Huawei App Gallery"
                        width="100"
                        height="82"
                      />
                    </a> */}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
